export default {
  isAuthorized: false,
  email: '',
  emailInitial: '',
  name: '',
  lastName: '',
  secondName: '',
  phone: '',
  phoneInitial: '',
  phoneMobile: '',
  fullName: '',
  inn: '',
  organizationName: '',
  legalAddress: '',
  kpp: '',
  bik: '',
  correspondentAccount: '',
  checkingAccount: '',
  bankName: '',
  canFullChangeProfile: false,
  isAgreeWithData: true,
};
